/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "~/db/db";
import { initialPath } from "~misc/paths";
import useModal from "~components/Modal/hooks/useModal";
import { getLocation } from "~services/utils/geoLocation";

import useLocalStorage from "~hooks/useLocalStorage";
import useRequisicoesOffline from "~fetchs/useRequisicoesOffline";
import {
  formatDateToCustomString,
  getPosOrCheckinData,
  setSendedSearch,
  updateData,
  updateNaoIds,
} from "../utils/searchHelpers";
import { randomId } from "~pages/Funnel/utils";
import { deviceType, isDesktop, isTablet } from "react-device-detect";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";

const useButtonsConfig = ({
  dados,
  idCliente,
  setShowButton,
  auto = true,
  setShowMessageModal,
  open,
  origem,
  cameFromVisitaView,
}) => {
  const { save } = useRequisicoesOffline();
  const { isModalOpen: isModalFechar, closeModal: closeModalFechar, openModal: openModalFechar } = useModal();
  const [loadingVisita, setLoadingVisita] = useState(null);
  const [loadingPost, setLoadingPost] = useState(false);

  const {
    isModalOpen: isModalOpenNaoConsome,
    closeModal: closeModalNaoConsome,
    openModal: openModalNaoConsome,
  } = useModal();

  const {
    isModalOpen: isModalOpenManterFechado,
    closeModal: closeModalManterFechado,
    openModal: openModalManterFechado,
  } = useModal();

  useEffect(() => {
    setLoadingVisita(false);
  }, [isModalOpenManterFechado, isModalOpenNaoConsome]);
  const {
    isModalOpen: isModalOpenManterNaoConsome,
    closeModal: closeModalManterNaoConsome,
    openModal: openModalManterNaoConsome,
  } = useModal();

  const navigate = useNavigate();

  const [campoFechadoNaoConsomeBasico, setCampoFechadoNaoConsomeBasico] = useState({
    id: 0,
    fecharConsome: "Fechar",
  });

  const [tipoMensagem, setTipoMensagem] = useState("");

  const { checkin } = useCheckIn();

  const [, setLocalStorage] = useLocalStorage("validation", null);
  const checkRouteRoteirizacao = (idCliente, idClienteRota) => {
    if (idClienteRota !== null && idClienteRota !== undefined) {
      setLocalStorage(idClienteRota);
      navigate(`/roteirizacao/${idClienteRota}`);
      return;
    }
    return null;
  };

  const inactiveSearchs = async (toModify = { ativo: false }) => {
    const now = new Date();
    const today =
      now.getFullYear() +
      "-" +
      String(now.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(now.getDate()).padStart(2, "0");
    const ids = [];

    await db.mapaDaMina
      .where("clienteId")
      .equals(parseInt(idCliente))
      .and((e) => e.ativo || e.createdAt.split("T")[0] === today)
      .each((e) => ids.push(e.id));

    if (ids?.length > 0) {
      await Promise.all(ids.map((id) => db.mapaDaMina.update(id, toModify)));
    }
  };

  const onError = (error) => {
    console.error(error);
  };

  function verificarURL() {
    const url = window.location.pathname;
    const regex = /^\/pesquisa-de-preco\/\d+(\/nova-pesquisa)?$/;

    const shouldRedirect =
      (origem === "roteirizacao" && regex.test(url)) ||
      (cameFromVisitaView === "true" && regex.test(url)) ||
      (checkin?.clienteId && +idCliente === checkin.clienteId && regex.test(url));

    if (shouldRedirect) {
      if (cameFromVisitaView === "true") {
        navigate(`/roteirizacao/consulta/${idCliente}`);
      } else if (checkin?.clienteId) {
        checkRouteRoteirizacao(checkin.clienteId, checkin.clienteId);
      } else {
        checkRouteRoteirizacao(+idCliente, +idCliente);
      }
    } else {
      const params = new URLSearchParams();
      if (cameFromVisitaView) params.append("cameFromVisitaView", cameFromVisitaView);
      if (origem) params.append("origem", origem);

      navigate(`${initialPath}/pesquisa-de-preco/${idCliente}${params.toString() ? "?" + params.toString() : ""}`);
    }
  }

  const onSuccess = async (response) => {
    if (response?.mapasMina) {
      setLoadingVisita(false);

      const id = parseInt(idCliente);
      const historyIds = response?.historyIds ?? [];

      await setSendedSearch({ clienteId: id, date: new Date(), data: {} });

      await updateNaoIds({ historyIds, clienteId: id }).then(async () => {
        await updateData({ data: response?.mapasMina, resetMapaDaMina: true, clienteId: id });
      });
    }
  };

  async function atualizarCampos(campo, fecharModal, extra = {}) {
    fecharModal();

    setLoadingPost(true);
    try {
      const location = await getLocation();
      const pos = getPosOrCheckinData({ pos: location, checkin });

      const dispositivo = isTablet ? "Tablet" : isDesktop ? "Desktop" : deviceType;

      setCampoFechadoNaoConsomeBasico({
        id: idCliente,
        fecharConsome: campo,
        dispositivo,
        ...pos,
        ...extra,
      });
    } catch (error) {
      onError(error);
      setLoadingPost(false);
      setLoadingVisita(false);
    }
  }

  const openMessage = () => {
    setShowMessageModal((prev) => ({
      ...prev,
      text: "Cliente temporariamente aberto",
      submessage: "Adicione e salve pesquisas para confirmar a ação.",
    }));
  };

  const toTempOpen = async () => {
    await inactiveSearchs({
      ativo: false,
      tempAberto: true,
    });
    await open();
    setLoadingVisita(false);

    openMessage();
  };

  async function checarFechado() {
    setLoadingVisita(true);
    try {
      if (dados?.fechado) {
        await toTempOpen();
        if (isModalFechar) closeModalFechar();
      } else {
        await atualizarCampos("Fechar", closeModalFechar);
      }
    } catch (error) {
      onError(error);
      setLoadingVisita(false);
    }
  }

  async function checarConsumo() {
    setLoadingVisita(true);
    try {
      if (!dados?.consomeBasico) {
        await toTempOpen();
        if (isModalOpenNaoConsome) closeModalNaoConsome();
      } else {
        await atualizarCampos("NaoConsome", closeModalNaoConsome);
      }
    } catch (error) {
      onError(error);
      setLoadingVisita(false);
    }
  }

  async function manterFechado() {
    setLoadingVisita(true);
    try {
      await atualizarCampos("Fechar", closeModalManterFechado, { manterFechado: true });
    } catch (error) {
      onError(error);
      setLoadingVisita(false);
    }
  }

  async function manterNaoConsomeBasico() {
    setLoadingVisita(true);
    try {
      await atualizarCampos("NaoConsome", closeModalManterNaoConsome, { manterFechado: true });
    } catch (error) {
      onError(error);
      setLoadingVisita(false);
    }
  }

  const saveDataToClose = async ({ field }) => {
    try {
      setLoadingPost(true);
      const id = parseInt(idCliente);
      const createdAt = formatDateToCustomString(new Date());
      setLoadingVisita(false);

      let pos = await getLocation();
      pos = getPosOrCheckinData({ pos, checkin });

      let fieldToSend = campoFechadoNaoConsomeBasico;
      const dispositivo = isTablet ? "Tablet" : isDesktop ? "Desktop" : deviceType;

      await db.mapaDaMina.put({
        id: randomId(),
        clienteId: id,
        clienteFechado: field == "fechado" ? createdAt : null,
        clienteNaoConsomeBasicos: field == "clienteNaoConsomeBasicos" ? createdAt : null,
        createdAt,
      });

      const obj = {
        id: randomId(15),
        type: "clienteFechadoConsomeBasicos",
        clienteId: id,
        toSend: {
          ...fieldToSend,
          ...pos,
          dispositivo,
        },
        createdAt,
        sended: false,
      };

      const response = await save(obj);
      if (response?.isOffline) {
        await setSendedSearch({ clienteId: id, date: new Date(), data: {} });
        if (field == "fechado" || field == "clienteNaoConsomeBasicos") {
          const message = (field == "fechado" ? "Cliente Fechado" : "Cliente Não Consome Básicos") + " - Modo Offline";

          setShowMessageModal((prev) => ({
            ...prev,
            text: message,
            onClose: async () => {
              await db.mapaDaMinaClienteFechado.put({
                clienteId: id,
                fechado: field == "fechado" ? "clienteFechado" : "clienteNaoConsomeBasicos",
              });

              verificarURL();
            },
          }));
        }
        setLoadingPost(false);
        return;
      }

      await onSuccess(response);

      if (field == "fechado" || field == "clienteNaoConsomeBasicos") {
        const message = field == "fechado" ? "Cliente Fechado" : "Cliente Não Consome Básicos";

        setShowMessageModal((prev) => ({
          ...prev,
          text: "Informações salvas com sucesso",
          submessage: message,
          onClose: async () => {
            await db.mapaDaMinaClienteFechado.put({
              clienteId: id,
              fechado: field == "fechado" ? "clienteFechado" : "clienteNaoConsomeBasicos",
            });

            verificarURL();
          },
        }));
      }
    } catch (error) {
      onError(error);
    } finally {
      setLoadingPost(false);
    }
  };

  useEffect(() => {
    if (campoFechadoNaoConsomeBasico.id) {
      saveDataToClose({
        field: ["Fechar"].includes(campoFechadoNaoConsomeBasico.fecharConsome) ? "fechado" : "clienteNaoConsomeBasicos",
      });
    }
  }, [campoFechadoNaoConsomeBasico]);

  useEffect(() => {
    if (dados && auto) {
      if (dados?.fechado || !dados?.consomeBasico) {
        if (dados?.fechado) {
          setTipoMensagem("fechado");
          buttonConfigs.fechado.open();
        } else if (!dados?.consomeBasico) {
          setTipoMensagem("nao-consome-basico");
          buttonConfigs.naoConsome.open();
        }
        setShowButton(false);
      } else {
        setShowButton(true);
        buttonConfigs.naoConsome.closeModal();
        buttonConfigs.fechado.closeModal();
      }
    }
  }, [dados]);

  const retornarMensagem = () => {
    switch (tipoMensagem) {
      case "alterar-fechado":
        return (
          <>
            {dados?.fechado ? (
              <>
                Este cliente não está ativo e será sinalizado <b className="text-recusado">como aberto</b>. Confirma a
                informação?
              </>
            ) : (
              <>
                Esta opção não se aplica a almoço, férias ou feriado. <br />
                Confirma que o cliente <b className="text-recusado">encerrou as atividades econômicas</b>?
              </>
            )}
          </>
        );
      case "alterar-consome-basico":
        return (
          <>
            Este cliente{" "}
            <b className="text-recusado">
              {dados?.consomeBasico ? "não" : ""} trabalha com produtos de material básico
            </b>
            . Confirma a informação?
          </>
        );
      case "fechado":
        return (
          <>
            Este cliente <b className="text-recusado">não</b> está ativo.
            <br />
            Para criar e visualizar as pesquisas, é necessário que o <br /> cliente não esteja fechado. <br />
            Deseja ativá-lo?
          </>
        );
      case "nao-consome-basico":
        return (
          <>
            Este cliente <b className="text-recusado">não consome materiais básicos</b>.<br />
            Para criar e visualizar as pesquisas, é necessário que o <br /> cliente seja um consumidor de materiais
            básicos. <br />
            Deseja alterar essa informação?
          </>
        );
      case "default-inativo":
        return (
          <>
            Este cliente está <b className="text-recusado">inativo</b>.<br />
            Deseja reativá-lo?
          </>
        );
    }
  };

  const buttonConfigs = {
    fechado: {
      isModal: isModalFechar,
      closeModal: closeModalFechar,
      redirectTo: () => verificarURL(),
      sub: retornarMensagem(),
      buttonLabel: "Sinalizar cliente fechado",
      link: null,
      action: () => checarFechado,
      open: openModalFechar,
    },
    naoConsome: {
      isModal: isModalOpenNaoConsome,
      closeModal: closeModalNaoConsome,
      redirectTo: () => verificarURL(),
      sub: retornarMensagem(),
      buttonLabel: "Cliente não consome básicos",
      link: null,
      action: () => checarConsumo,
      open: openModalNaoConsome,
    },
    manterFechado: {
      isModal: isModalOpenManterFechado,
      closeModal: closeModalManterFechado,
      redirectTo: () => verificarURL(),
      sub: (
        <>
          Este cliente está <b className="text-recusado">fechado</b>.<br /> Confirma que o cliente continua com as
          atividades econômicas encerradas?
        </>
      ),
      buttonLabel: "Manter cliente fechado",
      link: null,
      action: () => manterFechado,
      open: openModalManterFechado,
    },
    manterNaoConsome: {
      isModal: isModalOpenManterNaoConsome,
      closeModal: closeModalManterNaoConsome,
      redirectTo: () => verificarURL(),
      sub: (
        <>
          Este cliente não trabalha <b className="text-recusado">produtos básicos</b>.<br /> Confirma que o cliente
          continua sem trabalhar com produtos de material básicos?
        </>
      ),
      buttonLabel: "Manter cliente não consome básicos",
      link: null,
      action: () => manterNaoConsomeBasico,
      open: openModalManterNaoConsome,
    },
  };

  return {
    setTipoMensagem,
    buttonConfigs,
    checkRouteRoteirizacao,
    idCliente,
    checkin,
    loadingVisita,
    loadingPost,
  };
};

export default useButtonsConfig;
